/**
 * Lenis smooth scrolling.
 *
 * Lenis still drives the real window scroll position, so IntersectionObserver
 * keeps working — the donut charts, count-ups and reveals all fire as normal.
 *
 * Disabled entirely under prefers-reduced-motion: hijacking the scroll is
 * exactly what that setting is asking us not to do, and the page then falls
 * back to the browser's own scrolling.
 */

import Lenis from 'lenis';

let lenis: Lenis | null = null;

export function getLenis(): Lenis | null {
  return lenis;
}

export default function smoothScroll(): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  lenis = new Lenis({
    duration: 1.1,
    easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
  });

  const raf = (time: number) => {
    lenis?.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
}
